module.exports = __webpack_public_path__ + "img/iana2.511d0c3c.png";